// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#waiter-setting[data-v-879bee30]{max-width:1280px;margin-left:auto;margin-right:auto}#waiter-setting .box-header .title[data-v-879bee30]{font-size:22px;font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
